<template>
  <v-container py-0>
    <v-row>
      <v-col class="tip-wrapper pa-0" cols="12">
        <v-row>
          <v-col
            cols="5"
            class="py-3 pr-2 pb-0 pt-5 pl-1 play pointer"
            @click="item.videoSrc ? openVideo() : $router.push(articleLink)"
          >
            <v-img
              :src="previewImage"
              height="123px"
              max-width="120"
              cover
              class="item-image pointer"
              aspect-ratio="1"
            />
            <v-icon
              absolute
              color="#ffffff"
              size="60"
              class="absolute mdi mdi-youtube play-button"
              v-if="item.videoSrc"
            />
          </v-col>
          <v-col cols="7" class="guide-details pr-0 pl-2 pt-5 pb-0">
            <nuxt-link
              :to="articleLink"
              class="black--text pb-0"
              @click.prevent="log"
            >
              <h3 class="display-18 item-title">{{ title }}</h3>
            </nuxt-link>
            <TipFooter :item="item" breakLine />
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>
 
<script>
import ArticleLink from './mixins/ArticleLink';
import ArticleTitleVue from './mixins/ArticleTitle.js';
import ArticlePreviewImageVue from './mixins/ArticlePreviewImage.js';
import TipFooter from '@/components/Articles/TipFooter';

export default {
  mixins: [ArticleLink, ArticleTitleVue, ArticlePreviewImageVue],
  components: {
    TipFooter,
  },
  props: {
    item: {
      type: Object,
      required: false,
      videoArticle: true,
    },
  },
  methods: {
    openVideo() {
      this.$nuxt.$emit('openVideo', this.item.videoSrc);
    },
  },
};
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}

.tip-wrapper {
  background-color: #f6f7f9;
  height: 161px;
}
.tip-wrapper .item-image {
  border-radius: 5px;
  cursor: pointer;
}
.item-image {
  border-radius: 5px;
}
.item-title {
  font-weight: 400;
  line-height: 1.11;
}

.border-m {
  border-top: 1px solid #3e4a54;
  border-bottom: 1px solid #3e4a54;
}

.guide-details {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
@media screen and (max-width: 600px) {
  .item-title {
    font-size: 18px !important;
  }
}
.play {
  display: flex;
  justify-content: center;
  align-items: center;
}
.play-button {
  position: absolute;
  display: flex;
  justify-content: center;
  font-size: 50px;
  text-shadow: 0px 0px 10px #000000;
  align-items: center;
}
</style>
